import { KYMW7100Component } from "./kymw7100.component";
import { BundleCatalogModel } from "./vo/bundle-catalog.model";
import { BundleCatalogFormDataModel } from "./vo/bundle-catalog-form-data.model";
import { MediumTypeModel } from "./vo/medium-type.model";

export class KYMW7100Model {
  public kymw7100Component: KYMW7100Component;
  public mediumTypeList: MediumTypeModel[] = [];
  public formData: BundleCatalogFormDataModel = new BundleCatalogFormDataModel();
  public bundleCatalogList: BundleCatalogModel[] = [];
  public deletedBundleCatalog: BundleCatalogModel | null = null;

  clearDeletedBundleCatalog() {
    this.deletedBundleCatalog = null;
  }

  clearFormData() {
    this.formData = new BundleCatalogFormDataModel();
  }
}
